export const ENVMAPPING = (
  location: string
): {
  api: string;
  agentApi: string;
  azure_app_id: string;
  azure_client_id: string;
  s3bucket: string;
  track_request_url: string;
  origin?: string;
  enclaveSwitchUrl?: string;
} => {
  const localData = {
    azure_app_id: "ba96876a-c846-4b5f-9278-cbf1df45996e",
    azure_client_id: "9107b728-2166-4e5d-8d13-d1ffdf0351ef",
    track_request_url: "https://tmnatest.service-now.com",
  };

  if (location === "https://datascience.toyota.com") {
    return {
      api: "https://api.datascience.toyota.com/",
      agentApi: "https://datascience.toyota.com/",
      azure_app_id: "cff840a9-3f08-4681-b1b6-627238b2bf0e",
      azure_client_id: "8c642d1d-d709-47b0-ab10-080af10798fb",
      s3bucket: "s3://tdsp-datascience-tc-data-products/",
      track_request_url: "https://tmna.service-now.com",
      origin: "https://datascience.toyota.com",
      enclaveSwitchUrl: "https://enclave.datascience.toyota.com",
    };
  } else if (location === "https://nonprod.datascience.toyota.com") {
    return {
      api: "https://api.nonprod.datascience.toyota.com/",
      agentApi: "https://nonprod.datascience.toyota.com/",
      azure_app_id: "ba96876a-c846-4b5f-9278-cbf1df45996e",
      azure_client_id: "9107b728-2166-4e5d-8d13-d1ffdf0351ef",
      s3bucket: "s3://tdsp-nonprod-datascience-tc-data-products/",
      track_request_url: "https://tmnatest.service-now.com",
      origin: "https://nonprod.datascience.toyota.com",
      enclaveSwitchUrl: "https://enclave-nonprod.datascience.toyota.com",
    };
  }

  return {
    ...localData,
    api: "http://localhost:8000/api/",
    agentApi: "http://localhost:8000/api/",
    s3bucket: "s3://tdsp-veads-tc-data-products-dev/",
    enclaveSwitchUrl: "http://localhost:3000",
  };
};

export const toBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const dropdownSelectProps = {
  MenuProps: {
    PaperProps: {
      style: {
        maxHeight: 200,
      },
    },
  },
};

export const getFilteredRoles = (roles: any[]) => {
  if (!roles || !Array.isArray(roles)) { return []; }  
  const filtered = roles.filter(role => {
    const roleName = role.u_primary?.toLowerCase().trim();
    const shouldInclude = roleName !== 'data lead' && roleName !== 'data analyst';
    return shouldInclude;
  });
  return filtered;
};